import { EntityType, Module } from "@/constants";
import { RequestConfig } from "@/types";
import { AxiosRequestConfig } from "axios";
import RequestsService from "./RequestsService";

interface LogMeta {
  module: Module;
  entityType: EntityType;
  entityId: string;
  documentId?: string;
  freshdeskTicketId?: string;
}

const requestService = new RequestsService(Module.UNKNOWN);

class UnknownRequestsService {
  serviceName: string;
  module: Module;
  entityType: EntityType;
  entityId: string;
  documentId: string | undefined;
  freshdeskTicketId: string | undefined;

  constructor(serviceName: string) {
    this.serviceName = serviceName;
    this.module = Module.UNKNOWN;
    this.entityType = EntityType.UNKNOWN;
    this.entityId = EntityType.UNKNOWN;
  }

  log(logMeta: LogMeta) {
    this.module = logMeta.module;
    this.entityType = logMeta.entityType;
    this.entityId = logMeta.entityId;
    this.documentId = logMeta.documentId;
    this.freshdeskTicketId = logMeta.freshdeskTicketId;
    return this;
  }

  private send(requestConfig: RequestConfig) {
    let callerName;
    try {
      throw new Error();
    } catch (e: any) {
      callerName =
        e.stack
          .split("at ")?.[3]
          ?.split(" ")?.[0]
          ?.split(".")?.[1]
          ?.replace(/[A-Z]/g, (m: string) => "_" + m.toLowerCase()) ||
        "unknown";
    }
    return requestService.send({
      source: this.module,
      entityType: this.entityType,
      entityId: this.entityId,
      documentId: this.documentId,
      freshdeskTicketId: this.freshdeskTicketId,
      api: callerName,
      requestConfig: requestConfig,
    });
  }

  get(url: string, config?: AxiosRequestConfig) {
    return this.send({
      method: "GET",
      serviceName: this.serviceName,
      route: url,
      data: config?.data,
      query: config?.params,
      headers: config?.headers,
    });
  }

  post(url: string, data?: any, config?: AxiosRequestConfig) {
    return this.send({
      method: "POST",
      serviceName: this.serviceName,
      route: url,
      data: data,
      headers: config?.headers,
    });
  }

  put(url: string, data?: any, config?: AxiosRequestConfig) {
    return this.send({
      method: "PUT",
      serviceName: this.serviceName,
      route: url,
      data: data,
      headers: config?.headers,
    });
  }

  patch(url: string, data?: any, config?: AxiosRequestConfig) {
    return this.send({
      method: "PATCH",
      serviceName: this.serviceName,
      route: url,
      data: data,
      headers: config?.headers,
    });
  }

  delete(url: string, config?: AxiosRequestConfig) {
    return this.send({
      method: "DELETE",
      serviceName: this.serviceName,
      route: url,
      data: config?.data,
      query: config?.params,
      headers: config?.headers,
    });
  }
}

export function requests(serviceName: string) {
  return new UnknownRequestsService(serviceName);
}
